export default "__VITE_ASSET__yGFBhiKo__"